import React from 'react';
import type { Question, Language } from '@nordcrest/shared';

interface TextInputProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  language: Language;
  error?: string;
}

export function TextInput({ question, value, onChange, language, error }: TextInputProps) {
  const inputType = question.type === 'email' ? 'email' : question.type === 'phone' ? 'tel' : 'text';

  const placeholder = question.type === 'email'
    ? 'email@example.com'
    : question.type === 'phone'
      ? '+46 70 123 45 67'
      : '';

  return (
    <div>
      <input
        type={inputType}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      />
      {question.description && !error && (
        <p className="text-sm text-gray-500 mt-2">{question.description[language]}</p>
      )}
      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
    </div>
  );
}
